import $ from "jquery";
import "bootstrap/js/dist/modal";
import lightbox from "lightbox2";
/**
 * MAILTO MODAL IMAGE
 */
const initializeMailToButtons = () => {
    const buttons = document.querySelectorAll(".mailto");
    const modalImage = document.querySelector(".tattoModalImage");
    if (!buttons.length || !modalImage) {
        return;
    }
    buttons.forEach((button) => {
        button.addEventListener("click", () => {
            const { src } = button.dataset;
            if (!src) {
                return;
            }
            modalImage.src = src;
        });
    });
};
/**
 * PAGE SCROLL PROGRESS
 */
const initializeScrollProgress = () => {
    const scrollBar = document.querySelector("#scrollBar");
    if (!scrollBar) {
        return;
    }
    let ticking = false;
    const updateScrollProgress = () => {
        const scrollTop = Math.max(window.scrollY, document.documentElement.scrollTop, 0);
        const scrollHeight = document.documentElement.scrollHeight -
            document.documentElement.clientHeight;
        const progress = scrollHeight > 0
            ? (scrollTop / scrollHeight) * 100
            : 0;
        scrollBar.style.transform = `scaleX(${Math.min(Math.max(progress / 100, 0), 1)})`;
    };
    window.addEventListener("scroll", () => {
        if (ticking) {
            return;
        }
        ticking = true;
        window.requestAnimationFrame(() => {
            updateScrollProgress();
            ticking = false;
        });
    }, {
        passive: true,
    });
    updateScrollProgress();
};
/**
 * CURRENT YEAR
 */
const initializeCurrentYear = () => {
    const elements = document.querySelectorAll(".year");
    if (!elements.length) {
        return;
    }
    const currentYear = new Date().getFullYear();
    elements.forEach((element) => {
        element.textContent = String(currentYear);
    });
};
/**
 * BOOTSTRAP MODALS
 */
const initializeModals = () => {
    $(document).on("shown.bs.modal", () => {
        const modalImage = document.querySelector(".tattoModalImage");
        const input = document.querySelector(".hidden input");
        if (!modalImage || !input) {
            return;
        }
        input.value = modalImage.src;
    });
};
/**
 * LIGHTBOX
 */
const initializeLightbox = () => {
    lightbox.option({
        resizeDuration: 200,
        wrapAround: true,
    });
};
export const initializeContent = () => {
    initializeMailToButtons();
    initializeScrollProgress();
    initializeCurrentYear();
    initializeModals();
    initializeLightbox();
};
